export default {
  menus: {
    index: "Dashboard",
    Customer: "Customer",
    Order: "Order Status",
    OrderStatus: "Order Status",
    Report: "Report",
    ReportOne: "Net Sales Revenue Analysis",
    ReportTwo: "Overdue Account Receivables",
    ReportThree: "Order Intake and Shipped Report",
    ReportFour: "Customer Container Tracking Report（Surcharge）",
    ReportFive: "Ready CTNS To Ship",
    ReportSix: "Export Sales Analysis Per Customer",
    ReportSeven: "Export Sales Analysis Per Cover No",
    ReportEight: "Export Sales Analysis Per Model",
    ReportNine: "Sales Detail Report",
    ReportTen: "Service Order Status Report",
    ReportEleven: "Statement Of Business Shipments And Revenues",
    ReportTwenty: "Customer Line Up & Competition Summary",
    qsInventory:"Ship-A-Ton Inventory Report",
    relatingPrices:"Prices",
    Travel: "Travel",
    competitors: "Competing Products",
    competingGoods: "Pricelists",
    exhibition: "Commitments",
    Commitments: "Markets List",
    tableListbyCustomer: "Commitments List",
    tableList: "Summary by Customer",
    TotalCommitments: "Summary by Model",
    Video: "Video",
    Documents: "Documents",
    Catalog: "Documents",
    achievement: "Performance",
    resetPassword: "Reset Password",
    Performance: "Total",
    others: "Others",
    DFSEDIInvolce: "DFS EDI Involce",
    lmageVideo: "Images&Video",
    Cover: "Covers",
    CoverFeature: "Cover Feature",
    Admin: "Admin",
    Frames: "Frames",
    CoversRelated: "Covers Related",
    ContentRelated: "Content Related",
    Models: "Models List",
    modelsManager: "Models",
    Arms: "Arms",
    Backs: "Backs",
    Categories: "Categories",
    Features: "Features",
    Mechanisms: "Mechanisms",
    Seats: "Seats",
    SKU: "SKU",
    Styles: "Styles",
    Arrangements: "Arrangements",
    Covers: "Covers",
    CoversGrades: "Cover Grades",
    CoversGroups: "Cover Groups",
    Photos: "Photos",
    Videos: "Videos",
    Price: "Price",
    InventoryPlatform: "Inventory Platform",
    InventoryPlatformProductInfoConfig: "Product Information",
    InventoryPlatformCustomerData: "Customer Data",
    InventoryPlatformSharingReport: "Inventory Sharing Report",
    InventoryReport: "Order intake statement",
    RevenueReport: "Sales Revenue Shipping Report",
    InventoryPlatformCustomerDataNew: "Customer Data",
    NewStyleMaintenance: "New Model Maintain",
    ExhibitionBonusDistribution: "Exhibition Bonus Distribution",
    ExhibitionBonusStyles: "Exhibition Bonus Styles",
    SpecificationRelationship: "Specification Relationship",
    FollowUpSituationTable: "Market Order Statement",
    ConfirmOrderDetails: "Market Confirmed Order Details",
    MarketNewModelBonusReport: "Market New Model Bonus Report",
    NewModelRelated: "New Model Related",
    ExReservation: "Market Reservation",
    CustomerManagement: "Customer Management",
    CustomerSalesInfo: "Customer Information Management",
    cart: "Check List",
    poList: "PO List",
    OrderAverageDeliveryTime: "Customer Order Average Delivery",
  },
  others: {
    DFSEDIInvolce: {
      lnvoiceCode: "invoice Code",
      ExportEDIFile: "Export EDI File",
      EDIFileName: "EDI File Name",
      ExportPOFile: "Export POFile",
    },
  },
  dash: {
    Year: "Year",
  },
  Home: {
    Department: "Department",
    OverdueAmount: "Overdue Amount",
    SaleAmount: "Sales Amount",
    charTitle1: "Year-Over-Year Analysis",
    charTitle2: "Order Intake and Shipped Report",
    charTitle3: "Customer Sales Ranking",
    charTitle4: "Top Customers by Overdue Amount",
    charTitle5: "My Best Selling Models",
    charTitle6: "Department’s Best Selling Models",
    charTitle7: "My Best Selling Covers",
    charTitle8: "Department’s Best Selling Covers",
    tbTitle1: "Customer Name",
    tbTitle2: "Current Month's Sales",
    tbTitle3: "Same Month Last Year's Sales",
    tbTitle4: "Account Receivable",
    tbTitle5: "Growth Ratio%",
    more: "more",
    lastYear: "Last Year",
    thisYear: "This Year",
  },
  menusObj: {
    menu_title1: "Dashboard",
    menu_title2: "Customer",
    menu_title3: "Order Status",
    menu_title4: "Report",
    menu_title5: "Travel",
    menu_title6: "Competing Products",
    menu_title7: "Pricelist",
    menu_title8: "Commitments",
    menu_title9: "Video",
    menu_title10: "Documents",
    menu_title11: "Performance",
    menu_title12: "Images And Video",
    menu_title13: "Models",
    menu_title14: "Prices",
    menu_title15: "Customer Pricelists",
    menu_title16: "Markets",
    menu_title17: "portalCommitments",
  },
  pageTitle: {
    TravelList: "Travel List",
    Customer: " Customer",
    Order: "Order",
    OrderStatus: "Order Status",
    CustomerDet: "Customers Profile",
  },
  CustomerPage: {
    tabTitle1: " Sales Amount",
    tabTitle2: "Model Ranking",
    tabTitle3: "Surcharge",
    tabTitle4: "Lineup",
    tabTitle5: "Chargeback",
    OverdueAmount: "Overdue Amount",
    AccountReceivable: "Account Receivable",
    tb1: "Name",
    Cnumber: "Customer Number",
    Cname: "Account",
    Country: "Country",
    City: "City",
    PoCode: "Postal Code",
    tel: "Tel",
    addr: "Address",
    InCompany: "Insurance Company",
    paymentTerm: "PAYMENT TERM",
    CreditLine: "Credit Line",
    wip: "WIP",
    AmountReceivable: "Account Receivable",
    TOT: "Terms Of Trade",
    STP: "Ship-To-Party",
    Confirm: "Confirm",
    Fabric: "Material",
    quty: "Estimated Containers",
    CType: "Customer Type",
    AddBusinessCard: "Business Card",
    Attachment: "Attachment",
    Remark: "Remark(Specs.)",
    AddCustomer: "Commitment Form",
    CustomerDet: {
      thTitle1: "Date",
      thTitle2: "Current Month's Sales",
      thTitle3: "Same Period Last Year",
      thTitle4: "Growth Ratio%",
      thTitle5: "Expense Type",
      thTitle6: "Current Amount",
      thTitle7: "Sales Amount",
      thTitle8: "Model",
      thTitle9: "skuCode",
      thTitle10: "productCode",
      thTitle11: "SKU Code",
      thTitle12: "Model",
      thTitle13: "Arrangement",
      thTitle14: "Product Code",
      thTitle15: "Terms Of Trade",
      thTitle16: "Material",
      thTitle17: "Color",
      thTitle18: "Current Price",
      thTitle19: "Sales amount of this year",
      thTitle20: "Sales amount of last year",
      thTitle21: "Year-over-Year%",
      thTitle22: "Picture",
      thTitle23: "Sales Amount",
      thTitle24: "Percentage",
      thTitle25: "Brand",
      thTitle26: "Expiration Date",
      thTitle27: "Sales Department",
    },
    modelTye: "New Model to Customer",
    yes: "Yes",
    no: "No",
    saleDept: "Sales Department",
  },
  Customer: {
    CustomerManagement: "Customer Management",
    state: "State",
    LocalRanking: "Local Ranking",
    CustomerAnualSales: "Customer Anual Sales",
    ApproxFurnitureSales: "Approx Furniture Sales",
    ManWahSales: "ManWah Sales",
    TargetSales: "Target Sales",
    AddNewCustomerData: "Add New Customer Data",
    CustomerInformationion: "Customer Informationion",
    ViaitingTimeLately: "Visiting date",
    StoreNumber: "Store Qty",
  },
  OrderPage: {
    tabTitle1: "All",
    tabTitle2: "PI Issued",
    tabTitle3: "PI Signed",
    tabTitle4: "Factory confirmed",
    tabTitle5: "Scheduled",
    tabTitle6: "Finished",
    tabTitle7: "Shipped",

    Order: "Order",
    OrderDate: "Order Date",
    PONO: "PO NO",
    Destination: "Destination",
    PaymentTerms: "Payment Terms",
    payTerms: "Terms of payment",
    Period: "Capacity Fulfillment Period",
    indexTb: {
      t1: "Customer Code",
      t2: "Customer Name",
      t3: "PI Issued",
      t4: "PI Signed",
      t5: "Factory confirmed",
      t6: "Scheduled",
      t7: "Finished",
      t8: "Shipped",
      t9: "All",
    },
    thead: {
      title1: "Model",
      title2: "Desc.",
      title3: "Color",
      title4: "Quantity",
      title5: "Price",
    },
    orderlist: {
      th1: "Request Delivery Date",
      th2: "Order Receive Date",
      th3: "Request Completion Date",
      th4: "Frame",
      th5: "Color",
      th6: "Brand",
      th7: "Expected Material ready date",
      th8: "Actual Material ready date ",
      th9: "Estimated Completion Date",
      th10: "ETD",
      th14: "ETA",
      th11: "Actual Completion Date",
      th12: "Container No.",
      th13: "POD Status",
      th15: "Invoice Number",
      th16: "Invoice Amount",
      th17: "Actual Completion Date",
    },
  },
  OrderAverageDeliveryTime: {
    shipped:'Shipped',
    unshipped: 'Unshipped',
    orderCreateTime: 'Order Create Time',
    orderOccupationTime: 'Order Occupancy Time',
    no: 'No.',
    vpSales: 'VP/Sales',
    customerName: 'Customer',
    cargoState: 'Cargo State',
    orderQuantity: 'Order Quantity',
    orderA2C: 'PI Issued→Signed',
    orderC2D: 'PI Signed→Confirmed',
    orderD2Completed: 'PI Confirmed→Finished',
    orderCompleted2Vanning: 'Finished→Loaded',
    orderCompleted2Delivery: 'Finished→Shipped',
    total: 'Lead Time  PI Issued→PI Shipped',
    exportFileName:'Customer Order Average Delivery Time'
  },
  reportItem: {
    Title: "Report",
    ItemTitle1: "Net Sales Revenue Analysis",
    ItemTitle2: "Overdue Account Receivables",
    ItemTitle3: "Order Input And Shipping Report",
    ItemTitle4: "Customer Container Tracking Report（Surcharge）",
    ItemTitle5: "Ready CTNS To Ship",
    ItemTitle6: "Export Sales Analysis Per Customer",
    ItemTitle7: "Export Sales Analysis Per Cover No",
    ItemTitle8: "Export Sales Analysis Per Model",
    ItemTitle9: "Sales Detail Report",
    ItemTitle10: "Service Order Status Report",
    ItemTitle11: "Statement Of Business Shipments And Revenues",
  },
  reportpage1: {
    Ccode: "Customer Code",
    VPname: "VP Name",
    Cname: "Customer Name",
    title1: "This month invoice amount",
    title2: "Invoice amount of the same period last year",
    title3: "Month Ratio Compare",
    title4: "Invoice amount Current year",
    title5: "Prior Year's invoice amount",
    title6: "Year Ratio Compare",
    NTitle1: "Arrangement",
    NTitle2: "Estimated Containers",
    NTitle3: "Confirmed Orders QTY",
    NTitle4: "Total Amount (USD)",
    NTitle5: "Confirmed Containers",
  },
  reportpage2: {
    days: "days",
    Ccode: "Customer Code",
    Cname: "Customer Name",
    title1: "Insurance Company",
    title2: "Terms of payment",
    title3: "Account Receivable",
    title4: "Overdue Amount",
    title5: "Last Payment Date",
    title6: "Last Payment Amount",
  },
  reportpage4: {
    Ccode: "Customer Code",
    Cname: "Customer Name",
    ChassisFee: "Chassis Fee",
    DropPickUpFee: "Drop & Pick Up Fee",
    PrePull: "Pre Pull",
    YardStorage: "Yard Storage",
    OverTimeWaiting: "Over Time Waiting",
    Demurrage: "Demurrage",
    ChassisSplit: "Chassis Split",
    CustomsExam: "CustomsExam",
    ECD: "Extra Charge for Delivery",
    Totalcost: "Total additional cost",
  },
  reportpage8_7: {
    title0: "Cover Number",
    title1: "Model Number",
    title2: "This Month Amount",
    title3: "This Month Ratio",
    title4: "Prior Year Month Amount",
    title5: "Current Year Ratio",
    title6: "Month Ratio Compare",
    title7: "Current Year Amount",
    title8: "Prior Year Amount",
    title9: "Year Ratio Compare",
    Country: "Country",
    code: "Code",
    name: "Name",
    dept: "Dept.",
    ctn: "CTN in warehouse(40HQ)",
    Cname: "Customer Name",
    TradeTerms1: "1/Trade Terms",
    TradeTerms2: "2/Trade Terms",
  },
  reportpage9: {
    tips1: "The start date of receipt cannot be later than the end date",
    tips2: "Invoicing start date cannot be later than end date",
    tips3: "Only data within half a year can be exported after receiving orders",
    tips4: "Invoicing can only export data within half a year",
    search: {
      title1: "Department",
      title2: "Order Recived Date ",
      title3: "Brand",
      title4: "Invoicing Date",
      title5: "Cover",
    },
    thTitle: {
      title1: "Customer Code",
      title2: "Name",
      title3: "VP",
      title4: "Sales",
      title5: "Sales Dept",
      title6: "Brand",
    },
  },
  reportpage10: {
    tips1: "The start date of receipt cannot be later than the end date",
    tips2: "Invoicing start date cannot be later than end date",
    tips3: "Only data within half a year can be exported after receiving orders",
    tips4: "Invoicing can only export data within half a year",
    search: {
      title1: "Department",
      title2: "VP/Sales",
      title3: "Company",
      title4: "Date",
    },
    thTitle: {
      title1: "No",
      title2: "Division",
      title3: "VP/Sales",
      title4: "Customer",
      title5: "Travel date",
      title6: "Market",
      title7: "Commotment",
      title8: "Confim",
      title9: "Order intake in last month CNT",
      title10: "Order intake in last month $",
      title11: "Order intake in last year CNT",
      title12: "Order intake in last year $",
      title13: "Growth ratio%",
      title14: "Order intake in this month CNT",
      title15: "Order intake in this month $",
      title16: "Order intake in this year CNT",
      title17: "Order intake in this year $",
      title18: "Growth ratio%",
      title19: "Order intake in this years CNT",
      title20: "Order intake in this years $",
      title21: "Order intake in last year CNT",
      title22: "Order intake in last year $",
      title23: "Growth ratio%",
    },
  },
  reportpage11: {
    tips1: "The start date of receipt cannot be later than the end date",
    tips2: "Invoicing start date cannot be later than end date",
    tips3: "Only data within half a year can be exported after receiving orders",
    tips4: "Invoicing can only export data within half a year",
    search: {
      title1: "Department",
      title2: "VP/Sales",
      title3: "Company",
      title4: "Date",
    },
    thTitle: {
      title1: "No",
      title2: "Division",
      title3: "VP/Sales",
      title4: "Customer",
      title5: "shipped ctn qtys last month",
      title6: "amount",
      title7: "discount",
      title8: "commission/salary",
      title9: "shiped ctn qty this month",
      title10: "amount",
      title11: "shiped ctn qty next month",
      title12: "amount",
    },
  },
  report20: {
    classification: "Classification",
    leather: "Leather",
    Fabric: "Fabric",
    mwSlot: "MW Slot",
    floorSlot: "Floor Slot",
    picture: "Pic.",
    rank: "No.",
    FOBPrice: "FOB Price",
    LandedPrice: "Landed Price",
    RetailPrice: "Retail Price",
  },
  Competing: {
    tabTitle1: "Title",
    tabTitle2: "Price",
    tabTitle3: "Information",
    formlable0: "Title",
    formlable1: "Amount",
    formlable2: "Details",
    formlable3: "Describe",
    formlable4: "User",
    formlable5: "Date",
    formlable6: "Country",
  },
  competingGoodsInfo: {
    title1: "SKU",
    title2: "Description",
    title3: "Cubes",
    title4: "Length",
    title5: "Depth",
    title6: "Price",
    title7: "Total Price",
    Commitments: "Commitments",
  },
  formlabel: {
    createdDate:"Created Date",
    updateDate:"Update Date",
    Month: "Month",
    Quarter: "Quarter",
    Year: "Year",
    ResetBtn: "Reset",
    SearchBtn: "Search",
    SingleBtn1: "Order Intake",
    SingleCount:"Total Order Intake",
    SingleBtn2: "Order Shipped",
    SingleCounts:"Total Shipped",
    ReturnBtn: "Return",
    addBtn: "Add",
    submitBtn: "Submit",
    editBtn: "Edit",
    Department: "Department",
    downloadbtn: "Download",
    downloadTemplate: "Download Template",
    upload: "Upload",
    cancel: "Cancel",
    Selectfile: "Select file",
    classify: "Classify",
    title: "Title",
    delete: "Delete",
    handle: "Edit",
    keyword: "Keyword",
    createCommitment: "Create Commitment",
    import: "Import",
    export: "Export",
    exportData: "ExportData",
    Count:"Count"
  },
  Performance: {
    tabTitle0: "Customer ",
    tabTitle1: " Budget",
    tabTitle2: " Acutal",
    tabTitle3: " Acutal",
    tabTitle4: " Actual/Budget Ratio ",
    tabTitle5: " Growth Ratio",
    tabTitle6: " Budget ",
    tabTitle7: " Acutal ",
    tabTitle8: " Acutal ",
    tabTitle9: " Actual/Budget Ration ",
    tabTitle10: " Growth Ratio",
    tabTitle11: " Actual ",
    Division1: " Total",
    Division2: " Division Two",
    Division3: " Division Three",
    cabinet: "Ctn Qty",
    Budget: "Budget 2024 Jan-Dec",
    Acutal1: "Acutal 2023",
    Acutal2: "Acutal 2019",
    vpassistant: "VP Assistant",
    ESAPC: "Export Sales Analysis Per Customer",
    BIT: "Budget Import Template",
  },
  Documents: {
    uptime: "Upload date",
    filetitle: "Document title",
  },
  timeOptions: {
    today: "today",
    oneMonthAgo: "a month ago",
    threeMonthAgo: "three months ago",
    sixMonthAgo: "six months ago",
    startPlaceholder: "Start Date",
    endPlaceholder: "End Date",
  },
  TravelList: {
    byway: "Others",
  },
  ModelsDet: {
    title: "Pricing And Images",
  },
  Hello: "Sell More",
  PleaseSelect: "Please select",
  Brand: "Brand",
  DepPleaseSelectBrand: " Brand",
  StartDate: "Start Date",
  EndDate: "End Date",
  Date: "Date",
  types: "types",
  PleaseSelectType: "Please select type",
  modifyPassword: "modify password",
  oldPassword: "old password",
  newPassword: "new password",
  confirmPassword: "confirm password",
  confirm: "confirm",
  firstLogin: "First login or password is too simple",
  PleaseEnterNewPassword: "Please enter a new password",
  passwordRequirements: "Password must be at least 8 characters long and contain at least one uppercase letter, one lowercase letter, and one digit",
  PleaseConfirmPassword: "Please enter it again",
  confirmError: "Passwords do not match",
  passwordNoChange: "New password cannot be the same as the old password",
  order: {
    Division : "Division",
    Market: "Market",
    PleaseEnterTheSearchKeyword: "Please enter the search keyword",
  },
  prices: {
    Function: "Function",
    PieceCount: "Piece Count",
    CoverGrade: "Cover Grade",
    CoverType: "Cover Type",
    MotionType: "Motion Type",
    category: "category",
    MaterialInfo:"Cover Grade",
     MaterialClass: "Cover Type",
    PowerClass:"Motion Type",
    style:"Search by Model" ,
    factory:"choose factory",
    search:"Search",
    description:"Description",
    Cubes:"CUbs(cuft)",
    length:"Length(in)",
    Depth:"Depth(in)",
    height:"Height(in)",
    vietnamP:"Vietnam/FOB",
    Type:"Type",
    Edit:"Edit",
    change:"Edit",
    sceneGraph:"Lifestyle",
    rawPic:"Images",
    priceTickets:"Catalog",
    back:"View Arrangements",
    clickPreview:"Click on the Cover Grades to show all the prices",
    pricesImportTemplate:"Prices Import Template",
    exportPriceSheet:"Generate Quote Sheet",
    priceSheetFileName:"FileName for Quotesheet",
    priceSheetColorNum:"Select COlor Number for Quotesheet",
    selectPic:"Select a photo for Quotesheet",
    noPic:"No images available",
    quoteSheet:"Quote Sheet",
    chooseCover:"Available Covers"
  },
  Report: {
    PleaseEnterCodeOrName: "Please enter code or name",
    PleaseEnterNameSearch: "Please Enter Name Search",
    AllTypes: "All Types",
  },
  /*此处上边翻译已进行核对，此处之后进行编写*/
  loading: "loading",
  noMore: "noMore",
  ALLTYPES: "ALL TYPES",
  model: "Model",
  Temporarily: "Temporarily no data",
  menu: {
    menu_title15: "Markets List",
    menu_title16: "Commitments List",
    menu_title17: "Summary by Customer",
    menu_title18: "Summary by Model",
  },
  Commitments: {
    id: "ID",
    NewModelLaunchDate: "New Model Launch Date",
    MarketsStartDate: "Markets Start Date",
    MarketsEndDate: "Markets End Date",
    NewModelOrigin: "New Model Origin",
    OldModelReExhibit: "Old Model Re-Exhibit",
    OrderCutofftime: "Order Cutoff Date",
    ShippingCutoffTime: "Shipping Cutoff Date",
    Maintainer: "Maintainer",
    MaintenanceDate: "Maintenance Date",
    MaterialNumber: "Material Number",
    DescCombination: "Categories",
    MaintainTemplate: "New Model Maintain Template",
    ArrangementMaintainTemplate: "Arrangement Maintain template",
    ExhibitionBonusDistributionTemplate: "Exhibition Bonus Distribution Template",
    ExhibitionBonusStylesTemplate: "Exhibition Bonus Styles Template",
    MarketNameCN: "Market Name-CN",
    MarketNameEN: "Market Name-EN",
    SalesDepartment: "Sales Department",
    OrderPlaceDate: "Order Place Date",
    CustomerConfirmedDate: "Customer Confirmed Date",
    VPSales: "VP/Sales",
    CommitmentQTY: "Commitment QTY(ctn)",
    ConfirmedOrderQTY: "Confirmed Order QTY(ctn)",
    ConfirmedOrderAMT: "Confirmed Order AMT(USD)",
    PODate: "PO Date",
    RequestedReadyDate: "Requested Ready Date",
    ReasonForNotOrdering: "Reason For Not Ordering",
    BonusMonth: "Bonus Month",
    Nationality: "Nationality",
    OverdueDays: "Overdue Days",
    MaterialCode: "Material Code",
    StyleSpecifications: "Model-Desc.",
    POOrderNumber: "PO#",
    LineItemNumber: "Line Item Number",
    Title: "Title",
    Describe: "Describe",
    StartDate: "Start Date",
    endDate: "End Date",
    Country: "Country",
    CommitmentsList: "Commitments list",
    AddMarket: "Add Markets",
    MarketsList: "Markets List",
    MarketsName: "Market Name",
    NewCustomer: "New Customer",
    CustomerName: "Customer Name",
    selectCustomerName: "Please select Customer Name",
    selectCountry: "Please select Country",
    saleDeptInp: "Please Input Sales Department",
    Sales: "Sales",
    Covers: "Covers",
    Confirm: "Confirm",
    Edit: "Edit",
    Arrangements: "Arrangements",
    CustomerType: "Customer Type",
    NumberOfOrders: "QTY(pcs)",
    OrderAmount: "Order AMT(USD)",
    TotalAmount: "Total Amount",
    Color: "Color",
    quantity: "QTY",
    IMIC: "Invitation Market Customers Information",
    IMICT: "Invitation Market Customers Information Template",
    AnnualTurnover: "Annual turnover",
    ViaitingTimeLately: "Visiting time lately",
    Company: "Company",
    Customer: "Customer",
    StoreNumber: "Store number",
    MarketTime: "Market time",
    NewReGularCustomer: "New/ReGular customer",
    Email: "email/tel",
    Division: "Division",
    AddExReservation: "Add ExReservation",
    create: "Create",
    CommitmentConfirm: "Commitment Confirm",
    vpSalesExport: "VP/Sales Export",
    officeExport: "Office Export",
  },
  no:'No.',
  Tips: "Tips",
  PleaseSelectTheDownloadMethod: "Please select the download method!?",
  Download: "Download",
  CopyLinks: "Copy Links",
  Receivables: "Overdue Account Receivables",
  OrderInput: "Order Input Summary",
  OrderInputDetailList: "Order Input Detail List",
  Firstlevelreport: "First level report",
  Secondaryreport: "Secondary report",
  VisitTime: "Visit Time",
  addTravel: {
    CustomerName: "Please Input Customer Name",
    PleaseInputContacts: "Please Input Contacts",
    CustomerLocation: "Please Input Customer Location",
    CustomerDetailsP: "Please Input Customer DetailsP",
    Opportunity: "Please Input Opportunity",
  },
  addCompetitors: {
    PleaseInputTitle: "Please Input Title",
    PleaseInputAmount: "Please Input Amount",
    PleaseInputDetails: "Please Input Details",
    PleaseInputCustomerDescribe: "Please Input Customer Describe",
    PleaseInputUserName: "Please Input User Name",
    selectdate: "select date",
  },
  AmountIsNotANumber: "Amount is Not a number or",
  CountryNotselected: "Country Not selected or",
  FileIsNull: "file is null",
  UploadPicturesCaninJPGformat: "Upload pictures can only be in JPG format!",
  addSuccess: "add success",
  PleaseInputcovers: "Please Input covers",
  editPricelist: "editPricelist",
  PleaseSelectModel: "Please select model",
  factory: "Factory",
  PleaseSelectArrangements: "Please select arrangements",
  PleaseInputSku: "Please Input sku",
  PleaseInputDescription: "Please Input description",
  PleaseInputCubes: "Please Input cubes",
  PleaseInputLength: "Please Input length",
  PleaseInputDepth: "Please Input depth",
  PleaseInputPrice: "Please Input price",
  AddVideo: "Add Images&Video",
  EditVideo: "Edit Images&Video",
  AddCover: "Add Covers",
  EditCover: "Edit Cover",
  PleaseInputColor: "Please Input Color",
  PleaseInputTitle: "Please Input Title",
  uploadDocuments: "upload Documents",
  Normal: "Normal",
  LifeStyle: "Lifestyle Photo",
  Closeup: "Closeup",
  Videos: "Videos",
  CatalogPages: "Catalog Pages",
  ConfirmOperation: "Confirm operation",
  Downloads: "Downloads",
  AddtoEmaiddl: "Add to Email",
  Small: "Small",
  Medium: "Medium",
  Large: "Large",
  HiRes: "HiRes",
  SendContentViaEmail: "Send Content Via Email",
  ToSendToMultipleEmails: "To send to multiple emails,please add a com between addresses",
  AddData: "add Data",
  ClientName: " Client Name",
  PleaseInputBudge: "Please Input Budge",
  PleaseInput: "Please Input",
  BatchImport: "Batch import",
  SelectFile: "Select file",
  ImagesAndVideo: {
    EmailTo: "Email To",
    Subject: "Subject",
    Body: "Body",
    SendEmail: "Send Email",
    Clear: "Clear",
    remove: "remove",
    type: "Type",
  },
  price: {
    TypeToFilter: "Type to filter",
    Current: "Brand",
    NewModel: "New Model",
    table: {
      Image: "Image",
      Model: "Model",
      Brand: "Brand",
      Current: "Current",
      Arms: "Arms",
      Backs: "Backs",
      Seats: "Seats",
      Mechanisms: "Mechanisms",
      Features: "Features",
      Styles: "Styles",
      Collections: "Collections",
      Categories: "Categories",
      Remarks: "Remarks",
      handle: "Handle",
    },
    From: {
      ModelForm: "Model Form",
      Name: "Name",
      Remarks: "Remarks",
      Style: "Style features",
      Construction: "Construction",
      CountryOfOrigin: "Country of origin",
      Unique: "Unique",
      Arms: "Arms",
      CreateModel: "Create Model",
      Close: "Close",
    },
  },
  ShippedOrderSummary: "Shipped Order Summary",
  ShippedDetailList: "Shipped Detail List",
  util: {
    CopySuccess: "Copy success",
    ImageAddedtoEmail: "Image added to email",
    ImageAlreadyInEmail: "Image already in email",
  },
  resetPassword: {
    username: "username",
    pleaseEnterUsername: "Please enter username",
    reset: "Reset",
    resetSuccess: "Reset success",
    confirmReset: "Confirm reset password?",
    tip: "Tip",
  },
  covers: {
    coverName: "Cover Name",
    coverNumber: "Cover Code",
    coverGroup: "Cover Group",
    coverType: "Cover Type",
  },
  modelStatus: {
    running: "Running",
    newModel: "New Model",
    newCover: "New Cover",
    phasedOut: "Phase Out",
    dropped: "Dropped",
  },
  Admin: {
    index: "Index",
    name: "Name",
    code: "Code",
    weight: "Weight",
    width: "Width",
    height: "Height",
    isUsed: "Is Used",
    skuType: "SKU Type",
    seats: "Seats",
    description: "Description",
    arrangementType: "Arrangement Type",
    motion: "Motion",
    motionType: "Motion Type",
    pieceCount: "Piece Count",
    uniqueArrangment: "Unique Arrangement",
    group: "Group",
    type: "Type",
    status: "Status",
    component: "Component",
    skin: "Skin",
    add: "Add",
    edit: "Edit",
    yes: "Yes",
    no: "No",
    active: "Active",
    inactive: "Inactive",
    pleaseEnter: "Please enter",
    pleaseSelect: "Please select",
    deleteInfo: "This operation will permanently delete the file. Do you want to continue?",
    promptInfo:"The cubes have achieved to 2200 square feets",
    errorInfo:"Fail to delete",
    confirm: "Confirm",
    cancel: "Cancel",
    tips: "Tips",
    networkError: "Network error",
    grade: "Grade",
    color: "Color",
    arms: "Arm",
    mechanisms: "Functional Mech",
    backs: "Back Cushion",
    features: "Product Feature",
    seats2: "Seat Cushion",
    styles: "Styles",
    provenance: "Provenance",
    china: "China",
    vietnam: "Vietnam",
    chinavietnam: "China or Vietnam",
    mexico: "Mexico",
    image: "Image",
    models: "Model",
    loadability: "Loading Ability",
    leather: "Leather",
    content: "Content",
    categories: "Categories",
    priceRange: "Price Range",
    cubes: "Cubes",
    coverGrade: "Cover Grade",
    length: "Length",
    depth: "Depth",
    price: "Price",
    selectiveColor: "Available Color",
    spec: "Spec.",
    cube: "Cube",
    lwh: "Product Size L*W*H (in)",
    packageSize: "Packaged Size L*W*H (in)",
    packageMethod: "Package Method",
    addOnOption: "Add-on Option",
    addOnOption1: "Add To Purchase List",
    salesPrice: "Sales Price",
    amountSum: "Amount SUM",
    cubeSum: "Cube SUM",
    customized: "Customization",
    pleaseEnterQTY: "Please Enter Quantity",
    containerCaculation: "Container Caculation",
    settlementPO: "Create PO",
    POSettlement: "Create PO",
    addtoPo: "Add to PO",
    poNo: "PO No.",
    fax: "Fax",
    buyer: "Buyer",
    email: "Email",
    emailEnter: "Separated by semicolons for multiple email addresses.",
    freight: "Freight",
    cabinetType: "Cabinet Type",
    POType: "PO Type",
    category: "Category",
    leading: "Leading",
    marketNewModel: "Market New Model",
    discountAmount: "Discount Amount",
    ManufacturingPlant: "Manufacturing Plant",
    totalOrderAmount: "Total Order Amount",
    package: "Package",
    authorizedSignature: "Authorized Signature",
    signatureVerification: "Signature Verification",
    settingUp: "Setting Up",
    closing: "Closing",
    emailStatus: "Email Status",
    checkAll: "Check All",
    SAPStatus: "SAP Status",
    sentSuccessfully: "Sent Successfully",
    failToSend: "Fail To Send",
    PONo: "PO No.",
    SAPPI: "SAP PI",
    subtotal: "Subtotal",
    sendPo:"Copy PO",
    sendToSap: "Send To SAP",
    sendEmail: "Send Email",
    exportPO: "Export PO",
    discountRate: "Discount Rate",
    salesDiscount: "Sales Discount",
    clear: "Clear",
    notSigned: "You haven't signed yet, are you sure to submit?",
    amountTotal: "Amount SUM",
    cubeTotal: "Cube SUM",
    pleaseSelectPO: "Please first check the data to be operated on",
    pleaseSelectAvaliablePO: "All selected data must be valid",
    confirmDelete: "Confirm Delete?",
    offShelf: "Off Shelf",
    effective: "Effective",
    view: "Preview",
    userCode: "User Code",
    AllocateAmount: "Allocate Amount",
    position: "Position",
    readyDate: "Cargo Ready Date",
    marketModel: "Market Model",
    trait: "Feature",
    all: "All",
  },
  travel: {
    title: "Travel",
    year: "Year",
    month: "Month",
    visitCustomer: "Visit Customer",
    exportReport: "Export Report",
    travelName: "VP/SALES Name",
    visitTime: "Visit Time",
    visitMode: "Visit Mode",
    country: "Country",
    state: "Region",
    fullAddress: "Full Address",
    customerDetail: "Customer Detail",
    storeNum: "Store QTY",
    storeStyle: "Model QTY",
    mwStyle: "MW Model Num.",
    visitResult: "Visit Result",
    img: "Travel Image",
    businessCard: "Business Card",
    customerType: "Customer Type",
    new: "New customer",
    old: "Existing customer",
    customerName: "Customer Name",
    tel: "Tel",
    face: "In Person",
    shop: "Store Visit",
    other: "Other",
    followUp: "Pending Follow Up",
    competitors: "Competitors",
    company: "Competitors",
    placementNum: "Competitors Model QTY",
    competitorStyle: "Competitors Model Name",
    remark: "Remark",
    date: "Date",
    notBeEmpty: "cannot be empty",
    orders: "orders",
    shipping: "shipping",
    payment: "payment",
    quality: "quality",
    retailPrice: "Retail Price",
    TravelSchedule: "Travel Schedule",
    tips: "Please select at least one VP/Sales!",
    tips1: "Please select only one VP/Sales!",
  },
  InventoryPlatform: {
    seq: "Seq",
    customer: "Customer",
    customerCode: "Customer Code",
    customerName: "Customer Name",
    customerSKU: "Customer SKU#",
    mwSKU: "MW SKU#",
    model: "Model",
    color: "Color",
    item: "Desc.",
    fabricNumber: "Cover Code",
    numberOfStore: "Store QTY",
    storeFloorSampleQTY: "Store Floor Sample QTY",
    status: "Status",
    createUser: "Create User",
    createTime: "Create Time",
    operate: "Operate",
    enable: "Active",
    disable: "Inactive",
    remark: "Remark",
    save: "Save",
    saveSuccess: "Save successful",
    pleaseSelectData: "Please select data",
    CustomerInventoryInfoTpl: "Customer Inventory Information Template",
    ImportSuccessful: "Upload Successful",
    ProductInfo: "Product Information",
    ProductInfoTpl: "Product Information Template",
    customerDataTpl: "Customer Data Template",
    WeekStartTime: "Week Start Time",
    WeekEndTime: "Week End Time",
    ThisWeekInvoice: "Sold QTY",
    undeliveriedQTY: "Undeliveried QTY",
    CustomerInventory: "Actual Stock QTY",
    ProductInTransit: "In Transit",
    ProductInStock: "Product Stock QTY",
    ReplenishmentQTY:"Backup Order QTY",
    ReadyDate:"Ready Date",
    InProduction: "In Production",
    UnProduced: "Un-produced",
    MeterialAvailableStock: "Material Available Stock",
    MeterialInTransit: "Material In Transit",
    OrderQuantity: "Order Quantity",
    ShippedQuantity: "Shipped Quantity",
    ETD: "ETD",
    ETA: "ETA",
    Container: "Container#",
    StockQTY: "Stock QTY",
    IHOQ:"In Hand Order Qty",
    RequestReadyDate: "Request Ready Date",
    EstReadyDate: "Est. Ready Date",
    ActualReadyDate: "Actual Ready Date",
    deleteConfirm: "Do you want to delete the selected record?",
    prompt: "Prompt",
    confirm: "Confirm",
    cancel: "Cancel",
    deleteSuccessful: "Delete successful",
    supplier: "Supplier",
    shipTo: "Ship To",
    customerPo:"Customer Po",
    po: "PO",
    PO:"PO",
    weekDate: "Week Date",
    uploadTip1: "The file size cannot exceed 5M",
    uploadTip2: "The number of document lines cannot exceed 100 million",
    IncorrectDownload: "Incorrect Download",
    file: "File",
    basicInfo: "Basic Info",
  },
};
